import React, { Component, Fragment } from 'react';
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import Content from './Content'

class Portfoliotwo extends Component {
    render() {
        return (
            <Fragment>
                <Header />
                <Content />
                <section className="client-section">
                    <div className="container">
                    </div>
                </section>
                <Footer />
            </Fragment>
        );
    }
}

export default Portfoliotwo;